import { useQuery } from "@tanstack/react-query";
import { jwtDecode } from "jwt-decode";
import { useMemo } from "react";

import { authStorage } from "@/services/authStorage";

export const useAccessToken = () => {
  const { data: token = null, isLoading } = useQuery<string | null>({
    queryKey: ["accessToken"],
    queryFn: () => authStorage.getAccessToken(),
    staleTime: 5 * 60 * 1000,
  });

  const payload = useMemo(() => {
    if (!token) {
      return null;
    }

    try {
      return jwtDecode(token);
    } catch (error) {
      console.error("Failed to decode access token:", error);
      return null;
    }
  }, [token]);

  return { token, payload, isLoading };
};
